import React, { useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../components/common/Button";
import InputField from "../../components/form/InputField";
import CheckboxOption from "../../components/form/CheckboxOption";
import Checkbox from "../../components/form/Checkbox";
import { anketaService } from "../../services/api";
import { getMainInfoByName } from "../../backend/info/mainInfo";
import formatPhoneNumber from "../../utils/formatNumber";

const SignUpPage = () => {
  const isMiddle = useMediaQuery({ query: "(max-width: 1400px)" });
  const isSingle = useMediaQuery({ query: "(max-width: 700px)" });
  const isMedium = useMediaQuery({ query: "(max-width: 700px)" });
  const isSmall = useMediaQuery({ query: "(max-width: 450px)" });

  const formRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    birthYear: "",
    phone: "",
    militaryExperience: false,
    combatExperience: false,
    weaponExperience: false,
    drivingCategory: "",
    civilianExperience: "",
    privacyPolicy: false,
  });

  const [errors, setErrors] = useState({
    name: "",
    birthYear: "",
    phone: "",
    civilianExperience: "",
    privacyPolicy: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const validateForm = (updErrors = true) => {
    let valid = true;
    const newErrors = {
      name: "",
      birthYear: "",
      phone: "",
      civilianExperience: "",
      privacyPolicy: "",
    };

    if (!formData.name.trim()) {
      newErrors.name = "Це поле обов'язкове";
      valid = false;
    }

    if (!formData.birthYear.trim()) {
      newErrors.birthYear = "Це поле обов'язкове";
      valid = false;
    }

    if (
      parseInt(formData.birthYear.trim(), 10) < 1965 ||
      parseInt(formData.birthYear.trim(), 10) > 2007
    ) {
      newErrors.birthYear = "Ми приймаємо лише людей віком 18-60 років";
      valid = false;
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Це поле обов'язкове";
      valid = false;
    }
    // console.log(formData.phone);
    if (formData.phone.trim().length != 19) {
      newErrors.phone = "Некоректний номер";
      valid = false;
    }

    if (!formData.civilianExperience.trim()) {
      newErrors.civilianExperience = "Це поле обов'язкове";
      valid = false;
    }

    if (!formData.privacyPolicy) {
      newErrors.privacyPolicy = "Потрібно погодитись з політикою конфіденційності";
      valid = false;
    }

    if (updErrors) setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        setIsSubmitting(true);
        setSubmitError("");

        // Call the anketaService to create a new record
        const response = await anketaService.create(formData);

        // console.log("Form submitted successfully:", response);
        setSubmitSuccess(true);

        // Reset form after successful submission
        setFormData({
          name: "",
          birthYear: "",
          phone: "",
          militaryExperience: false,
          combatExperience: false,
          weaponExperience: false,
          drivingCategory: "",
          civilianExperience: "",
          privacyPolicy: false,
        });
      } catch (error) {
        console.error("Form submission error:", error);
        setSubmitError("Виникла помилка при відправленні форми. Будь ласка, спробуйте ще раз.");
        const formElement = document.querySelector("form");
        if (formElement) {
          const elementPosition = formElement.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: elementPosition - 160, behavior: "smooth" });
        }
      } finally {
        setIsSubmitting(false);
      }
    } else {
      // console.log("Form validation failed");
      const formElement = document.querySelector("form");
      if (formElement) {
        const elementPosition = formElement.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - 160, behavior: "smooth" });
      }
    }
  };

  return (
    <div style={styles.formWrapper}>
      <div style={{ ...styles.formWrapper, backgroundColor: "var(--orange)" }}>
        <div style={styles.headerContainer}>
          <p style={styles.formHeader}>Анкета на вступ до 210 ОШП</p>
          <p style={styles.requiredFieldsNote}>* - обов'язкові поля</p>
        </div>
      </div>
      <div style={{ ...styles.formWrapper, backgroundColor: "var(--black)" }}>
        <div style={styles.formContainer}>
          <p style={styles.privacyNote}>
            Ми не передаємо ваші особисті дані третім особам, наприклад, ТЦК
          </p>
        </div>
      </div>
      <div style={styles.formContainer} ref={formRef}>
        {submitSuccess ? (
          <div style={styles.successMessage}>
            <p>Дякуємо! Вашу заявку успішно відправлено.</p>
            <p>Ми зв'яжемося з вами найближчим часом.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={styles.formColumn}>
            {submitError && <p style={styles.formError}>{submitError}</p>}

            <div
              style={{
                ...styles.formRow,
                gridTemplateColumns: isSingle ? "1fr" : isMiddle ? "1fr 1fr" : "1fr 1fr 1fr",
              }}
            >
              <InputField
                heading={"Ім'я"}
                isRequired={true}
                hintText={"Ім'я"}
                errorMessage={errors.name}
                onChanged={(value) => {
                  setFormData({ ...formData, name: value });
                  if (value.trim()) {
                    setErrors({ ...errors, name: "" });
                  }
                }}
              />
              <InputField
                heading={"Рік народження"}
                isRequired={true}
                hintText={"1980"}
                errorMessage={errors.birthYear}
                onChanged={(value) => {
                  setFormData({ ...formData, birthYear: value });
                  if (value.trim()) {
                    if (parseInt(value.trim(), 10) < 1965 || parseInt(value.trim(), 10) > 2007) {
                      setErrors({
                        ...errors,
                        birthYear: "Ми приймаємо лише людей віком 18-60 років",
                      });
                    }
                    setErrors({ ...errors, birthYear: "" });
                  }
                }}
                type="number"
              />
              <InputField
                heading={"Контактний номер телефону"}
                isRequired={true}
                hintText={"+38 (0__) ___ __ __"}
                mask="+38 (0__) ___ __ __"
                initialValue="+38 (0"
                errorMessage={errors.phone}
                onChanged={(value) => {
                  setFormData({ ...formData, phone: value });
                  if (value.trim()) {
                    setErrors({ ...errors, phone: "" });
                  }
                }}
                type="text"
                min={1965}
                max={2007}
              />
              {isSingle && (
                <InputField
                  heading={"Ваш цивільний досвід"}
                  isRequired={true}
                  hintText={"Додаткові навички, уміння"}
                  onChanged={(value) => {
                    setFormData({ ...formData, civilianExperience: value });
                  }}
                />
              )}
              <CheckboxOption
                heading={"Досвід у силових структурах"}
                options={["Так", "Ні"]}
                selectedOption={-1}
                onSelect={(option) => {
                  setFormData({ ...formData, militaryExperience: option == 0 });
                }}
              />
              <CheckboxOption
                heading={"Бойовий досвід"}
                options={["Так", "Ні"]}
                selectedOption={-1}
                onSelect={(option) => {
                  setFormData({ ...formData, combatExperience: option == 0 });
                }}
              />
              <CheckboxOption
                heading={"Досвід зі зброєю"}
                options={["Так", "Ні"]}
                selectedOption={-1}
                onSelect={(option) => {
                  setFormData({ ...formData, weaponExperience: option == 0 });
                }}
              />
            </div>
            <div style={{ ...styles.formRow, gridTemplateColumns: isSingle ? "1fr" : "1fr 1fr" }}>
              <InputField
                heading={"Водійське посвідчення, категорія"}
                isRequired={false}
                hintText={"Категорія"}
                onChanged={(value) => {
                  setFormData({ ...formData, drivingCategory: value });
                }}
              />
              {!isSingle && (
                <InputField
                  heading={"Ваш цивільний досвід"}
                  isRequired={true}
                  errorMessage={errors.civilianExperience}
                  hintText={"Додаткові навички, уміння"}
                  onChanged={(value) => {
                    setFormData({ ...formData, civilianExperience: value });
                    if (value.trim()) {
                      setErrors({ ...errors, civilianExperience: "" });
                    }
                  }}
                />
              )}
            </div>

            <div style={styles.policyContainer}>
              <Checkbox
                state={formData.privacyPolicy}
                onClick={(value) => {
                  setFormData({ ...formData, privacyPolicy: value });
                  if (value) {
                    setErrors({ ...errors, privacyPolicy: "" });
                  }
                }}
              />
              <div style={styles.policyTextContainer}>
                <p style={styles.policyLabel}>
                  Натискаючи кнопку нижче,
                  ви погоджуєтесь з нашою{" "}
                  <a href="/privacy-policy" style={styles.policyLink}>
                    Політикою конфіденційності
                  </a>
                </p>
                {errors.privacyPolicy && <p style={styles.errorMessage}>{errors.privacyPolicy}</p>}
              </div>
            </div>

            <div style={styles.submitContainer}>
              <button
                style={styles.submitButton}
                type="submit"
                disabled={isSubmitting}
                onClick={() => {
                  validateForm(true);
                }}
              >
                <Button
                  text={isSubmitting ? "Надсилаємо..." : "Надіслати заявку"}
                  textColor={validateForm(false) == false ? "var(--light-grey)" : "var(--black)"}
                  hoverTextColor={
                    validateForm(false) == false ? "var(--light-grey)" : "var(--white)"
                  }
                  border={
                    validateForm(false) == false
                      ? "3px solid var(--light-grey)"
                      : "3px solid var(--black)"
                  }
                  hoverBorder={
                    validateForm(false) == false ? "3px solid var(--light-grey)" : "none"
                  }
                  backgroundColor={validateForm(false) == false ? "var(--white)" : "var(--white)"}
                  hoverBackgroundColor={
                    validateForm(false) == false ? "var(--white)" : "var(--black)"
                  }
                  fontSize={isSmall ? "1.2rem" : isMedium ? "1.5rem" : "1.8rem"}
                  lineHeight="3rem"
                  padding="0.5rem 2rem"
                  fontWeight="bold"
                  cursor={validateForm(false) == false ? "default" : "pointer"}
                  onClick={() => {}}
                />
              </button>
            </div>
          </form>
        )}

        <div style={styles.contactInfo}>
          <p>Якщо виникли запитання – зателефонуйте нам</p>
          <a
              href={formatPhoneNumber(getMainInfoByName("recruitmentPhone"))}
              style={styles.phoneLink}
            >
              {getMainInfoByName("recruitmentPhone")}
            </a>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  formWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "var(--white)",
    overflow: "hidden",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    width: "var(--main-container-width)",
    margin: "0 auto",
    paddingTop: "4rem",
    paddingBottom: "2rem",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    width: "var(--main-container-width)",
    margin: "0 auto",
    paddingTop: "2rem",
    paddingBottom: "2rem",
  },
  formHeader: {
    fontSize: "min(5rem,12vw)",
    fontWeight: "bold",
    color: "var(--dark-grey)",
    marginBottom: "1rem",
  },
  requiredFieldsNote: {
    fontSize: "min(1.875rem,5vw)",
    color: "var(--black)",
  },
  privacyNote: {
    color: "var(--orange)",
    fontSize: "min(2.5rem,6vw)",
    fontWeight: "bold",
  },
  formColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "4rem",
    marginTop: "4rem",
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "4rem",
  },
  policyContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: "1rem",
    marginTop: "1rem",
  },
  policyTextContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent:"center",
    height:"2rem",
  },
  policyLabel: {
    fontSize: "1.25rem",
    color: "var(--dark-grey)",
    margin: 0,
  },
  policyLink: {
    color: "var(--orange)",
    textDecoration: "underline",
  },
  submitContainer: {
    display: "flex",
    flexDirection: "row",
  },
  submitButton: {
    background: "none",
    border: "none",
  },
  contactInfo: {
    marginTop: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.5rem",
  },
  phoneLink: {
    fontSize: "2rem",
    color: "var(--orange)",
    fontWeight: "bold",
    textDecoration: "none",
  },
  errorMessage: {
    color: "#FF0000",
    fontSize: "0.875rem",
    marginTop: "0.25rem",
  },
  formError: {
    color: "#FF0000",
    fontSize: "1rem",
    padding: "1rem",
    backgroundColor: "rgba(255, 0, 0, 0.05)",
    borderRadius: "0.5rem",
    marginBottom: "1rem",
  },
  successMessage: {
    backgroundColor: "rgba(0, 128, 0, 0.1)",
    padding: "2rem",
    borderRadius: "0.5rem",
    marginTop: "2rem",
    textAlign: "center",
  },
};

export default SignUpPage;
